import React from 'react'
import { useThemeStore } from '@/stores/themeStore'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Switch } from '@/components/ui/switch'

// Colors and themes are set once for the whole company, so this page only
// holds per-device display preferences.
const fontSizeOptions = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Default' },
  { value: 'large', label: 'Large' },
]

const Settings = () => {
  const { fontSize, animations, setFontSize, setAnimations } = useThemeStore()

  return (
    <div className="app-page">
      <div>
        <h1 className="app-page-heading">Settings</h1>
        <p className="app-page-subheading">Display preferences for this browser. They don&apos;t sync to other devices.</p>
      </div>

      <Card className="max-w-2xl">
        <CardHeader>
          <CardTitle>Display</CardTitle>
          <CardDescription>Make the app easier to read on this device.</CardDescription>
        </CardHeader>
        <CardContent className="divide-y divide-slate-200">
          <div className="flex flex-col gap-3 pb-5 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p id="text-size-label" className="text-sm font-semibold text-slate-900">Text size</p>
              <p className="text-sm text-slate-500">Changes the size of text across the app.</p>
            </div>
            <div
              role="radiogroup"
              aria-labelledby="text-size-label"
              className="inline-flex gap-1 rounded-lg bg-slate-100 p-1"
            >
              {fontSizeOptions.map((option) => {
                const selected = fontSize === option.value
                return (
                  <button
                    key={option.value}
                    type="button"
                    role="radio"
                    aria-checked={selected}
                    onClick={() => setFontSize(option.value)}
                    className={`rounded-md px-3 py-1.5 text-sm font-semibold transition-colors ${
                      selected ? 'bg-white text-slate-900' : 'text-slate-600 hover:text-slate-900'
                    }`}
                  >
                    {option.label}
                  </button>
                )
              })}
            </div>
          </div>

          <div className="flex items-center justify-between gap-4 pt-5">
            <div>
              <p id="reduce-motion-label" className="text-sm font-semibold text-slate-900">Reduce motion</p>
              <p className="text-sm text-slate-500">Turns off transitions and animations.</p>
            </div>
            <Switch
              checked={!animations}
              onCheckedChange={(checked) => setAnimations(!checked)}
              aria-labelledby="reduce-motion-label"
            />
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default Settings
